module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/5_01a0c45da572819b3fed07ced06b7f72.png";